import * as S from "./FormMessage.styles";

export const FormMessage: React.FC<{ message: [string, boolean] | null }> = ({ message }) => {
    if (!message) return null;
    return <S.Message sentiment={message[1]}>{message[0]}</S.Message>;
}

export default FormMessage;
